import res from './res'

res.add('ru', {
    show: 'показать',
    hide: 'скрыть'
})
